import { render, staticRenderFns } from "./recomMenuDetail.vue?vue&type=template&id=c7c6df76&scoped=true&"
import script from "./recomMenuDetail.vue?vue&type=script&lang=js&"
export * from "./recomMenuDetail.vue?vue&type=script&lang=js&"
import style0 from "./recomMenuDetail.vue?vue&type=style&index=0&id=c7c6df76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c6df76",
  null
  
)

export default component.exports